//
// Copyright (c) 2011-2024 by Curalate, Inc
//

import React from 'react';

import HR from '@components/atoms/hr/HR';
import { CheckboxSetFilter } from '@components/media-filters/CheckboxSetFilter';
import { CollapsibleSection } from '@components/media-filters/CollapsibleSection';
import {
  FilterSection,
  FilterSectionTitle,
} from '@components/media-filters/filterSectionModels';

export interface OrientationFilterProps {
  isDisabled?: boolean;
  isInitiallyCollapsed?: boolean;
  section: FilterSection<string> | undefined;
  onChange: (section: FilterSection<string>) => void;
}

export const DEFAULT_ORIENTATION_FILTER_SECTION: FilterSection<string> = {
  options: [
    { isSelected: false, label: 'Vertical', value: 'Vertical' },
    { isSelected: false, label: 'Horizontal', value: 'Horizontal' },
    { isSelected: false, label: 'Square', value: 'Square' },
  ],
  paramKey: 'orientation',
};

export const OrientationFilter = ({
  isDisabled,
  isInitiallyCollapsed,
  section = DEFAULT_ORIENTATION_FILTER_SECTION,
  onChange,
}: OrientationFilterProps) => (
  <>
    <CollapsibleSection
      isCollapsed={isInitiallyCollapsed}
      title={FilterSectionTitle[section.paramKey]}
    >
      <CheckboxSetFilter
        isDisabled={isDisabled}
        onChange={onChange}
        section={section}
      />
    </CollapsibleSection>
    <HR />
  </>
);
